// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lpEo","label":"styles_label__1pGMV"};